<glo-page-wrapper>
  <article>
    <div class="container">
      <compass-pois></compass-pois>
    </div>
  </article>
</glo-page-wrapper>